import { Navigate } from 'react-router';
import { useAuth } from '../auth.tsx';
import { NorrbottenMap } from '../components/NorrbottenMap.tsx';
import { LinkButton, Loading } from '../components/ui.tsx';
import { useTitle } from '../hooks.ts';

const highlights = [
  {
    title: 'Förstå AI',
    text: 'Hur generativ AI fungerar, vad den kan och inte kan, och varför den ibland har fel.',
  },
  {
    title: 'AI i lärandet',
    text: 'Konkreta exempel från klassrummet, gränsen mellan hjälp och fusk och hur examinationen påverkas.',
  },
  {
    title: 'AI i samhället',
    text: 'Arbetsmarknaden, desinformation, snedvridning och EU:s AI-förordning – och vad det betyder för skolan.',
  },
];

export function HomePage() {
  const { user, loading } = useAuth();
  useTitle('');
  if (loading) return <Loading />;
  if (user) return <Navigate to="/kurs" replace />;

  return (
    <>
      <section className="aurora-sky overflow-hidden text-white">
        <div className="stars" />
        <div className="relative mx-auto max-w-6xl px-4 py-16 sm:py-24">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-aurora-400">
            Luleå tekniska universitet
          </p>
          <h1 className="mt-3 max-w-3xl text-4xl font-bold leading-tight sm:text-5xl">
            AI-litteracitet för alla lärare i Norrbotten
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-white/85">
            En kurs på cirka 40 timmar i din egen takt: korta filmer, texter, quiz och reflektioner
            tillsammans med kollegor i hela länet. När du är klar får du ett intyg.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <LinkButton to="/registrera" className="bg-white !text-night-900 hover:!bg-night-100">
              Skapa konto och börja
            </LinkButton>
            <LinkButton
              to="/logga-in"
              variant="ghost"
              className="!text-white ring-1 ring-white/40 hover:!bg-white/10"
            >
              Logga in
            </LinkButton>
            <LinkButton
              to="/om"
              variant="ghost"
              className="!text-white ring-1 ring-white/40 hover:!bg-white/10"
            >
              Om kursen
            </LinkButton>
          </div>
        </div>
      </section>
      <section className="mx-auto grid max-w-6xl gap-5 px-4 py-12 md:grid-cols-3">
        {highlights.map((h) => (
          <div key={h.title} className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-night-800/5">
            <h2 className="text-lg font-bold text-night-800">{h.title}</h2>
            <p className="mt-2 text-muted">{h.text}</p>
          </div>
        ))}
      </section>
      <section className="mx-auto max-w-6xl px-4 pb-14">
        <div className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-night-800/5 sm:p-8">
          <h2 className="mb-1 text-2xl font-bold text-night-900">Hela Norrbotten är med</h2>
          <p className="mb-6 text-muted">Så många lärare i varje kommun har tagit intyget.</p>
          <NorrbottenMap />
        </div>
      </section>
    </>
  );
}
